import { invalidateQueries } from '@leagueplatform/core';
import {
  GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
  GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
  GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
  completeUserHealthActivity,
  getUserHealthActivityById,
  postToolboxInteractionHub,
} from '@leagueplatform/health-journey-api';
import {
  buildPCPFhirSubmission,
  PCPSubmissionInfo,
} from './pcp-fhir-submission';

export function getPCPCampaignConfig() {
  const campaignId = import.meta.env.VITE_PCP_CAMPAIGN_ID?.trim();
  const activityId = import.meta.env.VITE_PCP_ACTIVITY_ID?.trim();
  if (!campaignId && !activityId) return undefined;
  if (!campaignId || !activityId) {
    throw new Error('PCP campaign configuration is incomplete');
  }
  return { campaignId, activityId };
}

export async function submitPCPRequest(
  info: PCPSubmissionInfo,
  config: { campaignId: string; activityId: string },
) {
  // This is the same definition-ID lookup used by suggested form deep links.
  // The backend resolves/enrolls the member; it does not rely on the visible list.
  const response = await getUserHealthActivityById(
    undefined,
    config.campaignId,
    config.activityId,
  );
  const activities = Array.isArray(response.data)
    ? response.data
    : [response.data];
  const matches = activities.filter(
    (activity) =>
      activity?.activityId === config.activityId &&
      activity.status === 'active',
  );
  if (matches.length !== 1) {
    throw new Error('No unique active PCP submission activity is available');
  }
  const activity = matches[0];
  const campaignId = activity.userHealthCampaign?.data?.campaignId;
  if (campaignId && campaignId !== config.campaignId) {
    throw new Error('Unexpected PCP submission campaign');
  }
  await postToolboxInteractionHub(buildPCPFhirSubmission(info, activity));
  // completedActivity finalizes the answers; completing the Task is a separate
  // SDK operation, matching the standard activity's last-page handler.
  await completeUserHealthActivity(activity.id);
  // Use the SDK cache, not the app's separate React Query client. Refresh the
  // same campaign/activity queries as SDK completion without its navigation.
  await Promise.all(
    [
      GET_USER_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
      GET_HEALTH_GOAL_PROGRAMS_MESSAGE_TYPE,
      GET_HEALTH_GOAL_PROGRAM_MESSAGE_TYPE,
      GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE,
    ].map((key) => invalidateQueries([key])),
  );
}
